import { gql } from '@apollo/client';

export const BOOKING_BY_REFERENCE = gql`
  query BookingByReference($id: Int!, $email: String!, $agencyId: Int!) {
    bookingByReference(id: $id, email: $email, agencyId: $agencyId) {
      id
      status
      statutReservation
      statutDisponibilite
      travelerCount
      totalPrice
      nom
      prenom
      mail
      telephone
      typeReservation
      annulationPar
      annuleLe
      createdAt
      package {
        id
        title
      }
      formula {
        id
        name
      }
    }
  }
`;
